/* eslint-disable */
const mutations = {
  updateIsLoading(state, { isLoading }) {
    state.isLoading = isLoading;
  },

  setBundle(state, { bundle }) {
    state.data = bundle;
  },

  updateBundle(state, { bundle }) {
    state.data = {
      ...state.data,
      ...bundle,
    };
  },
};

export default mutations;
